/**
 * 薛煜如
 * 缓存相关工具类
 */

function set(key, value){
  localStorage.setItem(key, JSON.stringify(value))
}

function get(key){
  let value = localStorage.getItem(key)
  if(!value || value == 'undefined') return value
  return JSON.parse(value)
}

function del(key){
  localStorage.removeItem(key)
}

export default {
  set,
  get,
  del
}